export const useLibraryBooksRemoveFromProfile = async (
  ids: string[]
): Promise<boolean> => {
  try {
    const { contents } = useProfileStore();

    const profileLoadFromNetwork = useProfileLoadFromNetwork();

    const allCurrentAddedIds = contents
      .filter((content) => content.type === UserContentType.Added)
      .map((content) => content.id);

    const addedAppIds = allCurrentAddedIds.filter((id) => !ids.includes(id));

    await useApiFetch(URI.AddAppIds, {
      method: 'POST',
      body: {
        addedAppIds,
      },
    });

    await profileLoadFromNetwork.run(true, false, true);
    return true;
  } catch (e) {
    return false;
  }
};
